import React from "react";

const sitesData = [
  {
    id: 15,
    name: "Amazon clone",
    time: "25.12.2020 - 03.02.2021",
    lan: "html, css, react, redux, firebase, stripe, nodejs, express",
    img: "/images/amazon.png",
    src: "https://clone-d3b6b.web.app/",
  },
  {
    id: 0,
    name: "Do'stlik Don",
    time: "15.01.2021 - 30.01.2021",
    lan: "html, css, bootstrap, reactstrap, react, hooks, api, redux",
    img: "/images/dostlikdon.png",
    src: "https://dostlikdon.netlify.app/",
  },
  {
    id: 1,
    name: "InformationBuySell",
    time: "05.10.2020 - 15.11.2020",
    lan: "html, css, bootstrap, javascript",
    img: "/images/InformationBuySell.png",
    src: "https://epic-noether-71928b.netlify.app/",
  },
  {
    id: 13,
    name: "Todo App",
    time: "30.01.2021",
    lan: "html, css, bootstrap, reactstrap, react",
    img: "/images/todo1.png",
    src: "https://mytodoappfirst.netlify.app/",
  },
  {
    id: 2,
    name: "Windows.uz",
    time: "10.12.2020 - 15.12.2020",
    lan: "html,scss, reactstrap, reactjs, hooks",
    img: "/images/windowsuz.png",
    src: "https://dreamy-jackson-97917c.netlify.app/",
  },
  {
    id: 3,
    name: "PDP.uz clone",
    time: "05.01.2021",
    lan: "html, css, scss, react, react hooks",
    img: "/images/pdpuz.png",
    src: "https://silly-hermann-564aa2.netlify.app/",
  },
  {
    id: 14,
    name: "Todo App",
    time: "15.12.2020",
    lan: "html, scc, bootstrap, reactstrap, react",
    img: "/images/todo2.png",
    src: "https://mytodoappsecond.netlify.app/",
  },
  {
    id: 4,
    name: "My Motivation App",
    time: "2 hours",
    lan: "html, css, bootstrap, react, react API",
    img: "/images/motivation.png",
    src: "https://abdulaziz-motivation.netlify.app/",
  },
  {
    id: 5,
    name: "Telegram Clone",
    time: "5 hours",
    lan: "html,css, scss, react ",
    img: "/images/telegramclone.png",
    src: "https://frosty-darwin-fe4aaf.netlify.app/",
  },
  {
    id: 6,
    name: "Lavish clone",
    time: "4-5 hours",
    lan: "html, css, boostrap, react",
    img: "/images/1-image.png",
    src: "https://competent-rosalind-205ad0.netlify.app/",
  },
  {
    id: 7,
    name: "TRVL clone",
    time: "3-4 hours",
    lan: "html, css, boostrap, react",
    img: "/images/image-2.png",
    src: "https://angry-lamarr-80b638.netlify.app/",
  },
  {
    id: 8,
    name: "Ciy Tour(learning)",
    time: "1-2 hours",
    lan: "html, css, boostrap, react",
    img: "/images/image-3.png",
    src: "https://zealous-haibt-3016c4.netlify.app/",
  },
  {
    id: 9,
    name: "SaSera",
    time: "7-8 hours",
    lan: "html, css, boostrap",
    img: "/images/image-4.png",
    src: "https://clever-mahavira-5703d9.netlify.app/",
  },
  {
    id: 10,
    name: "Matoa",
    time: "2 days",
    lan: "html, css, boostrap, javascript",
    img: "/images/matoa.png",
    src: "https://vigilant-varahamihira-2f2c3d.netlify.app/",
  },
  {
    id: 11,
    name: "Restore",
    time: "1 days",
    lan: "html, css, boostrap, javascript",
    img: "/images/restore.png",
    src: "https://hardcore-benz-33f13c.netlify.app/",
  },
  {
    id: 12,
    name: "Xuro",
    time: "1 days",
    lan: "html, css, boostrap, javascript",
    img: "/images/Xuro.png",
    src: "https://naughty-wiles-aaaad6.netlify.app/",
  },
];

function MySites() {
  return (
    <div className="mySites">
      <div className="commonBox">
        <h1>My Sites</h1>
        <div className="common"></div>
      </div>
      <div className="sitesBox">
        {sitesData.map((item) => (
          <div key={item.id} data-aos="fade-up">
            <div className="site">
              <img src={item.img} className="blog-img" alt="fa" />
              <div className="text-overlay">
                <h2>{item.name}</h2>
                <p>
                  {item.lan} &nbsp;&nbsp; <br />
                  <a href={item.src} target="blank" className="read-more">
                    Read More
                  </a>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MySites;
